var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSymbolikuvitus128046(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2,.cls-3,.cls-4{fill:none;stroke:#6e6e6e;}.cls-2,.cls-3{stroke-linecap:round;stroke-linejoin:round;stroke-width:1.25px;}.cls-3{fill-rule:evenodd;}.cls-4{stroke-miterlimit:10;opacity:0.2;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 128,
    height: 128
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M54.24,101.08,31.47,86.25c-2.4-1.26-4.46-.48-5.4.83-2.18,3,.55,5.09,1.07,5.58,3.12,2.38,18.66,14,25.54,18.8,4.66,3.22,8,5.89,19,5.74l31.37-1,6.37,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M76.88,107.56S72,107.19,61,107.47c-3.16.08-6.7-1.09-6.75-4.18.08-2.55,1.59-3.7,4.53-3.83l4.21.08c12.15.21,17.9-3.7,25.91-3.4a25.42,25.42,0,0,1,15.43,6.19l5.13.17"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 66.34,
    cy: 84.21,
    r: 9.03
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "63.82 82.12 67.12 79.97 67.12 88.44"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 77.66,
    cy: 63.77,
    r: 6.84
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M66.8,36.37a9.1,9.1,0,1,1,2.12,6.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M78.9,28.14c-.85-2.08-2-4.6-3-6.58C74,18,72.22,15.46,68.65,14.22L48.8,9.81a9.69,9.69,0,0,0-4.44.4L23.63,19.86l-5.08.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M18.55,38.16c1.91.39,4.29.9,6.54,1.46C30,40.85,36.16,45.09,42.19,46s31.43-.41,30-7c-.51-2.32-2.55-2.56-4.45-2.42-.4,0-19,4.36-20.25-4.34-1-7.22,3.86-9.1,10-9.47,5.59-.35,10,.68,13.15,5.9,0,.09.19.39.38.79"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 9.56,
    y: 17.24,
    width: 8.99,
    height: 23.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 109.45,
    y: 100.15,
    width: 8.99,
    height: 18.14
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolikuvitus128046);
export default __webpack_public_path__ + "static/media/symbolikuvitus_128_046.ee6f0745749e1f27071cb2f7907a0cca.svg";
export { ForwardRef as ReactComponent };